import { DoqType } from '@ardoq/doq';
import { ViewIds } from '@ardoq/api-types';
import { connect } from '@ardoq/rxbeach';
import { emptyView$ } from 'views/streams/emptyView$';
import { NoConnectedComponentsDoq } from '@ardoq/graph';
import { type I18nLocale } from '@ardoq/i18n';
import { NoDataAvailableDoq } from 'tabview/graphViews/emptyStates/NoDataAvailableDoq';
import { NoDataWithFiltersDoq } from 'tabview/graphViews/emptyStates/NoDataWithFiltersDoq';
import { onViewSettingsUpdate } from 'tabview/onViewSettingsUpdate';

type EmptyStateProps = {
  noConnectedComponents: boolean;
  hasActiveFilter: boolean;
  isPresentationMode: boolean;
  isWorkspaceEmpty: boolean;
  i18nLocale: I18nLocale;
};

const EmptyStateBase = ({
  hasActiveFilter,
  noConnectedComponents,
  isPresentationMode,
  isWorkspaceEmpty,
  i18nLocale,
}: EmptyStateProps) => {
  if (isWorkspaceEmpty) {
    return (
      <NoDataAvailableDoq
        doqType={DoqType.DEPENDENCY_MATRIX_ERROR}
        includeActions={!isPresentationMode}
      />
    );
  }

  if (noConnectedComponents) {
    return (
      <NoConnectedComponentsDoq
        doqType={DoqType.DEPENDENCY_MATRIX_ERROR}
        viewId={ViewIds.DEPMATRIX}
        includeActions={!isPresentationMode}
        onViewSettingsUpdate={onViewSettingsUpdate}
        i18nLocale={i18nLocale}
      />
    );
  }

  if (hasActiveFilter) {
    return (
      <NoDataWithFiltersDoq
        doqType={DoqType.DEPENDENCY_MATRIX_ERROR}
        includeActions={!isPresentationMode}
      />
    );
  }

  return null;
};

export const EmptyState = connect(EmptyStateBase, emptyView$);
